import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionRegistration } from 'app/models/convention-registration.model';
import { DailyRegister } from 'app/models/daily-register.model';
import { DeleteConventionRegistrationHistory } from 'app/models/delete-convention-registration-history.model';
import { Event } from 'app/models/event.model';
import { ExceptionList } from 'app/models/exception-list.model';
import { NoteExtension } from 'app/models/extensions/note-extension.model';
import { ProcessedEntityCredential } from 'app/models/processed-entity-credential.model';
import { ProcessedEntity } from 'app/models/processed-entity.model';

export class Note extends NoteExtension {
  noteDBID: number = 0;
  notes: string = null;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conventionRegistrations: ConventionRegistration[] = [];
  dailyRegisterDevNotes: DailyRegister[] = [];
  dailyRegisterLocalCommentNotes: DailyRegister[] = [];
  dailyRegisterPCTCommentNotes: DailyRegister[] = [];
  dailyRegisterPCTHiddenCommentNotes: DailyRegister[] = [];
  dailyRegisterQualifyToReceiveOverrideNotes: DailyRegister[] = [];
  dailyRegisterQualifyToSitOverrideNotes: DailyRegister[] = [];
  deleteConventionRegistrationHistoryDeleteNotes: DeleteConventionRegistrationHistory[] = [];
  deleteConventionRegistrationHistoryNotes: DeleteConventionRegistrationHistory[] = [];
  events: Event[] = [];
  exceptionLists: ExceptionList[] = [];
  processedEntityBringForwardFileNotes: ProcessedEntity[] = [];
  processedEntityCredentials: ProcessedEntityCredential[] = [];
  processedEntityNotes: ProcessedEntity[] = [];
  processedEntityQualifyToReceiveOverrideNotes: ProcessedEntity[] = [];
  processedEntityQualifyToSitOverrideNotes: ProcessedEntity[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      noteDBID: new FormControl({ value: 0, disabled: disableAll }),
      notes: new FormControl({ value: null, disabled: disableAll }),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      conventionRegistrations: new FormArray([]),
      dailyRegisterDevNotes: new FormArray([]),
      dailyRegisterLocalCommentNotes: new FormArray([]),
      dailyRegisterPCTCommentNotes: new FormArray([]),
      dailyRegisterPCTHiddenCommentNotes: new FormArray([]),
      dailyRegisterQualifyToReceiveOverrideNotes: new FormArray([]),
      dailyRegisterQualifyToSitOverrideNotes: new FormArray([]),
      deleteConventionRegistrationHistoryDeleteNotes: new FormArray([]),
      deleteConventionRegistrationHistoryNotes: new FormArray([]),
      events: new FormArray([]),
      exceptionLists: new FormArray([]),
      processedEntityBringForwardFileNotes: new FormArray([]),
      processedEntityCredentials: new FormArray([]),
      processedEntityNotes: new FormArray([]),
      processedEntityQualifyToReceiveOverrideNotes: new FormArray([]),
      processedEntityQualifyToSitOverrideNotes: new FormArray([])
    });


    return form;
  }
}